var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectColumnIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 4,
    fill: "#06223A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.76929 13.077V17.9231",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23071 7.53851L8.23071 17.9231",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6924 11L11.6924 17.9231",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5385 6.15387C15.5385 7.13099 14.7464 7.92311 13.7692 7.92311C12.7921 7.92311 12 7.13099 12 6.15387C12 5.17676 12.7921 4.38464 13.7692 4.38464C14.7464 4.38464 15.5385 5.17676 15.5385 6.15387ZM15.3418 8.43357C14.8951 8.74228 14.3533 8.92311 13.7692 8.92311C12.2398 8.92311 11 7.68328 11 6.15387C11 4.62447 12.2398 3.38464 13.7692 3.38464C15.2986 3.38464 16.5385 4.62447 16.5385 6.15387C16.5385 6.73795 16.3576 7.27978 16.0489 7.72646L18.6228 10.3003C18.818 10.4956 18.818 10.8122 18.6228 11.0074C18.4275 11.2027 18.1109 11.2027 17.9157 11.0074L15.3418 8.43357Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectColumnIcon);
export default __webpack_public_path__ + "static/media/selectColumnIcon.59438b3aa1b89e993e182387601dd088.svg";
export { ForwardRef as ReactComponent };